import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SliderService {
  sliderImages: string[] = [
    "images/statuetka_sks/statuetka_1.webp",
    "images/gryfy/gryf_1.webp",
    "images/intymnosc/intymnosc_2.webp",
    "images/medal_lukasz_zbroja/medal_5.webp",
    "images/slider/zakopane_1.webp",
  ];
}
